export default __webpack_public_path__ + "static/media/logo-print.a1f5bba4.png";